import { ISelectItem, Pill } from "@react-gcc-eds/core";
import { useState } from "react";
import { stringSorter } from "../../utils";

export const MultiSelectLimitedPills = ({
  data,
  onClick,
  onRemove,
  isDisabled
}: {
  data: ISelectItem<string>[];
  onClick?: () => void;
  onRemove: (items: ISelectItem[]) => void;
  isDisabled: boolean;
}) => {
  const [showAllPills, setShowAllPills] = useState(false);

  const WrapperPill = ({
    dataElement,
    onClick,
    onRemove,
    isDisabled
  }: {
    dataElement: ISelectItem<string>;
    onClick?: () => void;
    onRemove: (items: ISelectItem[]) => void;
    isDisabled: boolean;
  }) => {
    return (
      <span>
        <Pill
          className="pill"
          key={`pill-${dataElement.value}`}
          onClick={onClick}
          onRemove={() => {
            const dataElementRemoved = data.filter(d => d.value !== dataElement.value);
            onRemove(dataElementRemoved);
          }}
          disabled={isDisabled}
        >
          <span title={dataElement.title}>{dataElement.title}</span>
        </Pill>
      </span>
    );
  };

  const sortedData = data && data.sort(stringSorter<ISelectItem<string>>(c => c.title));

  if (data === undefined || data.length === 0) {
    return <></>;
  } else if (showAllPills) {
    return (
      <div className="pill-row-shared">
        {data.map(dataElement => (
          <WrapperPill
            dataElement={dataElement}
            onClick={onClick}
            onRemove={onRemove}
            isDisabled={isDisabled}
            key={`pill-${dataElement.value}`}
          />
        ))}
      </div>
    );
  } else if (sortedData.length <= 2) {
    return (
      <div className="pill-row-shared">
        {sortedData.map(dataElement => (
          <WrapperPill
            dataElement={dataElement}
            onClick={onClick}
            onRemove={onRemove}
            isDisabled={isDisabled}
            key={`pill-${dataElement.value}`}
          />
        ))}
      </div>
    );
  } else {
    return (
      <div className="pill-row-shared">
        <WrapperPill
          dataElement={sortedData[0]}
          onClick={onClick}
          onRemove={onRemove}
          isDisabled={isDisabled}
        />
        <span>
          <Pill onToggle={() => setShowAllPills(true)} disabled={isDisabled}>
            <span>{`+${sortedData.length - 1} More`}</span>
          </Pill>
        </span>
      </div>
    );
  }
};
